<div class="flex-column gap-widget">
	<div class="bg-rounded pad-M">
		<app-network-routers *ngIf="initialized" [network]="network" [routers]="routers"></app-network-routers>
		<app-dashboard-page-loader *ngIf="!initialized"></app-dashboard-page-loader>
	</div>
	<div class="bg-rounded pad-M">
		<app-infrastructure-schema *ngIf="initialized" [infrastructure]="schema" [from]="'network'"></app-infrastructure-schema>
		<app-dashboard-page-loader *ngIf="!initialized"></app-dashboard-page-loader>
	</div>
</div>
